import React, { useEffect, useState } from "react";
import Select from "react-select";
import InputField from "../../components/form/inputField/inputField";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { AdminButton } from "../../components/buttons/versionHistoryBtn";
import ErrorMsg from "../../components/form/errorMsg";
import back from "../../assets/back.svg";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import "./cfa.css";
import { useDispatch } from "react-redux";
import { headQuaterList } from "../../redux/actions/fieldForceAction";
import {
  fetchCityList,
  fetchDistrictList,
  fetchStateList,
} from "../../redux/actions/commonActions";
import {
  cfaDetail,
  cfaDistributorList,
  cfaEdit,
} from "../../redux/actions/cfaAction";
import CreatableSelect from "react-select/creatable";
import ChangeSaved from "../../components/popups/ChangeSaved";
import InputCapitalField from "../../components/form/inputField/inputCapitalField";
import ErrorPopup from "../../components/popups/ErrorPopup";
import LoadingSpinnerTable from "../../components/utilites/loader";
import useReactRouterBreadcrumbs from "use-react-router-breadcrumbs";

const CFAEdit = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  const [cfaData, setCfaData] = useState(null);
  const [edited, setEdited] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");
  const [stateOptions, setStateOptions] = useState([]);
  const [selectedState, setSelectedState] = useState(null);
  const [loading, setLoading] = useState(false);

  const phoneRegex = /^([+]\d{2})?\d{10}$/;
  const pincoderegex = /^[1-9]{1}[0-9]{2}\s{0,1}[0-9]{3}$/;

  useEffect(() => {
    setLoading(true);
    dispatch(cfaDetail(params.id, fetchCfadetailSuccess, fetchCfadetailError));
  }, []);
  const fetchCfadetailSuccess = (data) => {
    setLoading(false);
    console.log(data.data.data);
    setCfaData(data.data.data);
  };

  const fetchCfadetailError = (err) => {
    setLoading(false);
  };

  useEffect(() => {
    dispatch(fetchStateList(onGetStateSuccess, onGetStateError));
  }, []);

  const onGetStateSuccess = (data) => {
    console.log(data);
    let newArr = data.data.data.states.map((ele) => ({
      value: ele.id,
      label: ele.name,
    }));
    setStateOptions(newArr);
    console.log();
  };

  const onGetStateError = (err) => {
    console.log(err);
  };

  const initialValues = {
    cfa_id: cfaData?.id,
    cfa_name: cfaData?.cfa_name,
    cfa_depot_manager: cfaData?.cfa_depot_manager,
    mobile: cfaData?.mobile,
    alternate_mobile: cfaData?.alternate_mobile,
    email: cfaData?.email,
    address_one: cfaData?.address?.address_one,
    address_two: cfaData?.address?.address_two,
    address_three: cfaData?.address?.address_three,
    landmark: cfaData?.address?.landmark,
    state_id: cfaData?.state_id,
    pincode: cfaData?.pincode,
  };

  const validationSchema = Yup.object().shape({
    cfa_name: Yup.string().trim().required("Required"),
    cfa_depot_manager: Yup.string().trim().required("Required"),
    mobile: Yup.string()
      .trim()
      .matches(phoneRegex, "Not a valid Number")
      .required("Required"),
    alternate_mobile: Yup.string()
      .trim()
      .matches(phoneRegex, "Not a valid Number")
      .required("Required"),
    email: Yup.string().trim().email("Not a proper email").required("Required"),
    address_one: Yup.string().trim().required("Required"),
    address_two: Yup.string().trim().required("Required"),
    address_three: Yup.string().trim().required("Required"),
    // landmark: Yup.string().trim().required("Required"),

    pincode: Yup.string()
      .trim()
      .matches(pincoderegex, "Not a valid Number")
      .required("Required"),
  });

  const resetFunc = (setFieldValue) => {
    setFieldValue("cfa_name", cfaData?.cfa_name);
    setFieldValue("firm_name", cfaData?.cfa_depot_manager);
    setFieldValue("email", cfaData?.email);
    setFieldValue("mobile", cfaData?.mobile);
    setFieldValue("alternate_mobile", cfaData?.alternate_mobile);
    setFieldValue("address_one", cfaData?.address?.address_one);
    setFieldValue("address_two", cfaData?.address?.address_two);
    setFieldValue("address_three", cfaData?.address?.address_three);
    setFieldValue("landmark", cfaData?.address?.landmark);
    setFieldValue("pincode", cfaData?.pincode);
  };

  const onSubmit = (values) => {
    console.log("values", values);
    values["address"] = {
      address_one: values.address_one,
      address_two: values.address_two,
      address_three: values.address_three,
      landmark: values.landmark,
    };
    dispatch(cfaEdit(values, onSuccess, onError));
  };

  const onSuccess = (data) => {
    console.log(data);
    setEdited(true);

    const timeOutFnc = () => {
      setEdited(false);
      navigate("/cfa");
    };

    setTimeout(timeOutFnc, 2000);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const onError = (err) => {
    console.log(err);
    setShowErrorPopup(true);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
  };

  const routes = [
    { path: "/", breadcrumb: "Admin" },
    {
      path: "/cfa",
      breadcrumb: " / cfa",
    },
    {
      path: "/cfa/edit/:id",
      breadcrumb: cfaData?.cfa_id ? ` / ${cfaData?.cfa_id} - edit` : " / edit",
    },
  ];

  const breadcrumbs = useReactRouterBreadcrumbs(routes, {
    disableDefaults: true,
  });

  return (
    <>
      <div className="products-page fn_Nunito">
        <div className="products-main-div">
          <div className="mx-3">
            {breadcrumbs.map(({ match, breadcrumb }) => (
              <NavLink
                key={match.pathname}
                to={match.pathname}
                className="header-route-page fw_400 cursor_pointer"
              >
                <span className="fs_18">{breadcrumb}</span>
              </NavLink>
            ))}
          </div>
          <div className="products-main-list my-2 py-1">
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              enableReinitialize={true}
              onSubmit={onSubmit}
            >
              {({ errors, setFieldValue, values }) => (
                <Form className="">
                  <div className="search-container d-flex justify-content-between align-items-center">
                    <div
                      className="d-flex align-items-center p-2 ms-3 m-1 mb-2 cursor_pointer"
                      onClick={() => navigate(-1)}
                    >
                      <img src={back} alt="back_btn" />
                      <span className="px-2 dark_grey_color fs_16 fn_Nunito fw_600">
                        BACK
                      </span>
                    </div>
                    <div className=" d-flex justify-content-between m-1 mb-2">
                      {/* <VersionHistoryBtn link="#" /> */}

                      <AdminButton
                        background="#E7E5FF"
                        width="100px"
                        onClick={() => resetFunc(setFieldValue)}
                        type="button"
                      >
                        RESET
                      </AdminButton>
                      <AdminButton
                        background="#2AD3E7"
                        color="white"
                        width="100px"
                        type="submit"
                      >
                        <span className="m-2">SAVE</span>
                      </AdminButton>
                    </div>
                  </div>
                  <div style={{ position: "relative" }}>
                    {loading == true ? (
                      <div className="list-spinner-container">
                        <LoadingSpinnerTable />
                      </div>
                    ) : (
                      <div className="scrolling">
                        <div className="form-width ms-4 mt-4 pt-2 ps-3 py-1">
                          <div className="my-2">
                            <label className="color_b0b3c7 fs_14">CFA ID</label>
                            <p className="color_262c3d fs_15">
                              {cfaData?.cfa_id}
                            </p>
                          </div>
                          <div className="my-2">
                            <InputCapitalField
                              setFieldValue={setFieldValue}
                              id={"cfa_name"}
                              label={"CFA Name"}
                              labelColor={"color_747f9e"}
                              type={"text"}
                              placeholder={"Enter CFA name"}
                              name={"cfa_name"}
                              value={values?.cfa_name}
                            />
                          </div>
                          <div className="my-2">
                            <InputCapitalField
                              setFieldValue={setFieldValue}
                              id={"cfa_depot_manager"}
                              label={"CFA Depot Manager Name"}
                              labelColor={"color_747f9e"}
                              type={"text"}
                              placeholder={"Enter CFA depot manager name"}
                              name={"cfa_depot_manager"}
                              value={values?.cfa_depot_manager}
                            />
                          </div>
                          <div className="my-2">
                            <InputField
                              id={"email"}
                              label={"CFA Email Address"}
                              labelColor={"color_747f9e"}
                              type={"text"}
                              placeholder={"Enter email address"}
                              name={"email"}
                              value={values?.email}
                            />
                          </div>
                          <div className="my-2">
                            <InputField
                              id={"mobile"}
                              label={"CFA Depot Manager Mobile Number"}
                              labelColor={"color_747f9e"}
                              type={"text"}
                              placeholder={"Enter mobile number"}
                              name={"mobile"}
                              maxLength={10}
                              value={values?.mobile}
                            />
                          </div>
                          <div className="my-2">
                            <InputField
                              id={"alternate_mobile"}
                              label={"Alternate Mobile Number"}
                              labelColor={"color_747f9e"}
                              type={"text"}
                              placeholder={"Enter alternate mobile number"}
                              name={"alternate_mobile"}
                              maxLength={10}
                              value={values?.alternate_mobile}
                            />
                          </div>
                          <div className="my-2">
                            <label className="color_b0b3c7 fn_Nunito fs_14">
                              Address
                            </label>
                            <Field name={"address_one"}>
                              {({ field, meta }) => (
                                <input
                                  {...field}
                                  placeholder="Address line 1"
                                  id={"address_one"}
                                  className={
                                    "w-100 address-input-field py-2 my-1"
                                  }
                                />
                              )}
                            </Field>
                            <Field name={"address_two"}>
                              {({ field, meta }) => (
                                <input
                                  {...field}
                                  placeholder="Address line 2"
                                  id={"address_two"}
                                  className={
                                    "w-100 address-input-field py-2 my-1"
                                  }
                                />
                              )}
                            </Field>
                            <Field name={"address_three"}>
                              {({ field, meta }) => (
                                <input
                                  {...field}
                                  placeholder="Address line 3"
                                  id={"address_three"}
                                  className={
                                    "w-100 address-input-field py-2 my-1"
                                  }
                                />
                              )}
                            </Field>
                            {(errors.address_one && (
                              <ErrorMsg name={"address_one"} />
                            )) ||
                              (errors.address_two && (
                                <ErrorMsg name={"address_two"} />
                              )) ||
                              (errors.address_three && (
                                <ErrorMsg name={"address_three"} />
                              ))}
                          </div>
                          <div className="my-2 mt-4">
                            <InputField
                              id={"landmark"}
                              label={"landmark"}
                              labelColor={"color_747f9e"}
                              type={"text"}
                              placeholder={"Enter landmark"}
                              name={"landmark"}
                              value={values?.landmark}
                            />
                          </div>
                          <div className="w-100">
                            <label className="w-100 color_262c3d fn_Nunito fs_14">
                              State
                            </label>
                            <Field name={"state_id"}>
                              {({ field, meta }) => (
                                <Select
                                  {...field}
                                  options={stateOptions}
                                  styles={customStyles}
                                  placeholder={"Select state"}
                                  value={stateOptions.filter(
                                    (s) => s.value == values.state_id
                                  )}
                                  onChange={(selected) => {
                                    setSelectedState(selected?.value);
                                    setFieldValue("districts", []);
                                    setFieldValue("state_id", selected?.value);
                                  }}
                                />
                              )}
                            </Field>
                            <ErrorMsg name="state_id" />
                          </div>
                          <div className="my-2">
                            <InputField
                              id={"pincode"}
                              label={"Pincode"}
                              labelColor={"color_747f9e"}
                              type={"text"}
                              placeholder={"Enter pincode"}
                              name={"pincode"}
                              value={values?.pincode}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </Form>
              )}
            </Formik>

            <ChangeSaved show={edited} title={"CFA Edited Successfully"} />
            <ErrorPopup
              show={showErrorPopup}
              title={showErrorMsg}
              handleClose={closeErrorPopup}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default CFAEdit;

export const customStyles = {
  indicatorSeparator: () => ({ display: "none" }),
  control: (base, state) => ({
    ...base,
    border: "1px solid #B0B3C7",
    color: "#464646",
    fontFamily: "Nunito Sans",
    fontWeight: "400",
    fontSize: "15px",
    borderRadius: "8px",
    width: "100%",
    height: "43px",
    boxShadow: state.isFocused ? null : null,
    "&:hover": {},
  }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      color: "#B0B3C7",
      fontSize: "14px",
      fontFamily: "Nunito Sans",
    };
  },
  dropdownIndicator: (base) => ({
    ...base,
    color: "#a9a3e3", // Custom colour
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "#E7E5FF" : null,
    color: "#00000",
    // fontFamily: "Nunito",
    "&:hover": {
      backgroundColor: state.isFocused ? "#E7E5FF" : "#E7E5FF",
    },
  }),
};
